"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestDatepicker = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _format = _interopRequireDefault(require("date-fns/format"));

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _canUseDom = _interopRequireDefault(require("rc-util/lib/Dom/canUseDom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _propValidators = require("../utils/propValidators");

var _Calendar = _interopRequireDefault(require("../Calendar"));

var _InputBase = _interopRequireDefault(require("../Input/InputBase"));

var _forwardRef = _interopRequireDefault(require("../utils/forwardRef"));

var _getTabbableElements = _interopRequireDefault(require("../utils/getTabbableElements"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function isValidDate(value, format) {
  var date = (0, _parse["default"])(value, format);
  var formattedDate = (0, _format["default"])(date, format);
  return formattedDate === value;
}

var propTypes = {
  className: _propTypes["default"].string,
  defaultValue: _propValidators.dateSetType,
  due: _propValidators.dateSetType,
  format: _propTypes["default"].string,
  id: _propTypes["default"].string,
  label: _propValidators.accessibleLabelType.isRequired,
  late: _propValidators.dateSetType,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onEnter: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onOpenChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  unavailable: _propValidators.dateSetType,
  value: _propTypes["default"].oneOfType([_propValidators.dateType, _propTypes["default"].arrayOf(_propValidators.dateType)])
};
var defaultProps = {
  value: undefined,
  defaultValue: undefined,
  format: 'MM/DD/YYYY',
  id: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onClick: function onClick() {},
  onEnter: function onEnter() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onOpenChange: function onOpenChange() {},
  onSelect: function onSelect() {},
  placeholder: 'mm/dd/yyyy'
};

var Datepicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Datepicker, _Component);

  // Why not state?
  function Datepicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.calendarRef = /*#__PURE__*/_react["default"].createRef();
    _this.lastCalendarElement = null;
    _this.shouldKeepPopupOpen = false;

    _this.setLastCalendarElement = function () {
      var showPopup = _this.state.showPopup;

      if (showPopup) {
        var tabbableElements = (0, _getTabbableElements["default"])(_this.calendarRef.current);
        _this.lastCalendarElement = tabbableElements[tabbableElements.length - 1];
      }
    };

    _this.handleCalendarMouseDown = function (event) {
      event.preventDefault();
    };

    _this.handleCalendarSelect = function (value) {
      var onSelect = _this.props.onSelect;
      onSelect(value);

      _this.setState({
        inputValue: undefined,
        showPopup: false,
        value: value
      });
    };

    _this.handleInputBlur = function (event) {
      var onBlur = _this.props.onBlur;
      onBlur(event); // keep popup open when blur is caused by tab. i.e. tab between calendar cells

      if (_this.shouldKeepPopupOpen) {
        _this.shouldKeepPopupOpen = false;
      } else {
        _this.setState({
          showPopup: false
        });
      }
    };

    _this.handleInputChange = function (event) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          onChange = _this$props.onChange,
          format = _this$props.format;
      var value = event.target.value;
      onChange(event);

      _this.setState({
        showPopup: true
      });

      if (isValidDate(value, format)) {
        var date = (0, _parse["default"])(value, format);
        onSelect(date);

        _this.setState({
          inputValue: undefined,
          value: date
        });
      } else if (value === '') {
        _this.setState({
          inputValue: value,
          value: null
        });
      } else {
        _this.setState({
          inputValue: value
        });
      }
    };

    _this.handleInputClick = function (event) {
      var onClick = _this.props.onClick;
      onClick(event);

      if (event.target.className.includes('grv-textfield__input')) {
        _this.setState({
          showPopup: true
        });
      }
    };

    _this.handleInputEnter = function (event) {
      var onEnter = _this.props.onEnter;
      onEnter(event);

      _this.setState(function (prevState) {
        var showPopup = !prevState.showPopup;
        return {
          showPopup: showPopup
        };
      });
    };

    _this.handleInputFocus = function (event) {
      var onFocus = _this.props.onFocus;
      onFocus(event);

      _this.setState({
        showPopup: true
      });
    };

    _this.handleInputKeyDown = function (event) {
      var shiftKey = event.shiftKey,
          keyCode = event.keyCode,
          target = event.target; // onKeyDown for InputBase will trigger for all child components including
      // the Calendar popup. Check what element the keyDown originated from

      var inputIsActive = target.className.includes('grv-textfield__input');

      if (inputIsActive) {
        var onKeyDown = _this.props.onKeyDown;
        onKeyDown(event);
      }

      var shouldTabOffCalendar = (0, _canUseDom["default"])() && document.activeElement === _this.lastCalendarElement;

      if (keyCode === 9 && !(inputIsActive && shiftKey) && !shouldTabOffCalendar) {
        _this.shouldKeepPopupOpen = true;
      }
    };

    _this.state = {
      showPopup: false,
      value: props.value || props.defaultValue
    };
    return _this;
  }

  var _proto = Datepicker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setLastCalendarElement();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    this.setLastCalendarElement();
    var onOpenChange = this.props.onOpenChange;
    var showPopup = this.state.showPopup;

    if (showPopup !== prevState.showPopup) {
      onOpenChange(showPopup);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        due = _this$props2.due,
        format = _this$props2.format,
        id = _this$props2.id,
        late = _this$props2.late,
        onOpenChange = _this$props2.onOpenChange,
        onSelect = _this$props2.onSelect,
        placeholder = _this$props2.placeholder,
        unavailable = _this$props2.unavailable,
        propsValue = _this$props2.value,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["className", "due", "format", "id", "late", "onOpenChange", "onSelect", "placeholder", "unavailable", "value"]);

    var _this$state = this.state,
        showPopup = _this$state.showPopup,
        stateValue = _this$state.value,
        inputValue = _this$state.inputValue;
    var classes = (0, _classnames["default"])('grv-datepicker', className);

    var calendarPopup = /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-datepicker-popup"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-datepicker__content",
      ref: this.calendarRef
    }, /*#__PURE__*/_react["default"].createElement(_Calendar["default"], {
      due: due,
      id: id + "__calendar",
      late: late,
      onMouseDown: this.handleCalendarMouseDown,
      onSelect: this.handleCalendarSelect,
      unavailable: unavailable,
      value: propsValue || stateValue
    })));

    return /*#__PURE__*/_react["default"].createElement(_InputBase["default"], _extends({}, otherProps, {
      className: classes,
      id: id,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
      onClick: this.handleInputClick,
      onEnter: this.handleInputEnter,
      onFocus: this.handleInputFocus,
      onKeyDown: this.handleInputKeyDown,
      placeholder: placeholder,
      popup: showPopup ? calendarPopup : null,
      value: propsValue === null ? '' : propsValue && (0, _format["default"])(propsValue, format) || inputValue || stateValue && (0, _format["default"])(stateValue, format) // TODO - How do we know this is not a list of dates?

    }));
  };

  return Datepicker;
}(_react.Component);

Datepicker.propTypes = propTypes;
Datepicker.defaultProps = defaultProps;
var TestDatepicker = Datepicker;
exports.TestDatepicker = TestDatepicker;

var _default = (0, _forwardRef["default"])((0, _withId["default"])(Datepicker));

exports["default"] = _default;